import axios from 'axios';
import apiConfig from '../../api.config';

export default function sendBookingReport({ data }) {
  const {
    host,
    URIs: { sendBookingReport },
  } = apiConfig;

  const uri = `${host}${sendBookingReport.replace(':guestId', data.id)}`;

  return axios
    .put(uri, JSON.stringify(data), {
      headers: {
        'Content-Type': 'application/json',
      },
    })
    .then(res => {
      return res.data;
    });
}
